import { useEffect } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import MinusButton from "../../../../components/MinusButton";
import PlusButton from "../../../../components/PlusButton";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { IFields } from "../types";

interface CustomReportFieldsProp {
  customFields: Array<IFields>;
  selectedColumns: [];
}

const defaultFields = [
  {
    parentRow: true,
    tableName: "customFields",
  },
] as Array<IFields>;

const CustomReportFields: React.FC<CustomReportFieldsProp> = ({
  selectedColumns,
  customFields = defaultFields,
}) => {
  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name:
      customFields?.length > 0 && customFields[0]?.tableName
        ? "customFields"
        : "",
  });

  const tableArray =
    customFields?.length > 0 && watch(`${customFields[0].tableName}`);
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
    }));

  useEffect(() => {
    if (customFields) {
      replace(customFields);
    }
  }, [customFields]);

  const AddOrOpt = [
    { label: "AND", value: "AND" },
    {
      label: "OR",
      value: "OR",
    },
  ];
  return (
    <>
      <div className="m-2 bg-white box-shadow rounded-lg h-full">
        <div className="text-quinary font-bold font-sans py-2 px-4">
          Filter By
        </div>
        {controlledFields &&
          controlledFields.map((field, index) => {
            return (
              <div className="grid sm:grid-cols-10 pb-1" key={field.id}>
                <div className="col-span-1 grid sm:grid-cols-2 px-2">
                  <div
                    className={`col-span-1 self-center w-1/2 ml-8 ${
                      index < 1 && customFields[0].parentRow === true && "mt-4"
                    }`}
                  >
                    {index > 0 ? (
                      <MinusButton
                        type="button"
                        onClick={() => remove(index)}
                      />
                    ) : (
                      <PlusButton
                        type="button"
                        onClick={(e) => {
                          if (selectedColumns?.length > 0) {
                            append({
                              tableName: "customFields",
                              parentRow: false,
                            });
                          }
                        }}
                      />
                    )}
                  </div>{" "}
                </div>
                <div className={`col-span-2 w-full items-center gap-1 text-xs`}>
                  {index < 1 && customFields[0].parentRow === true && (
                    <label className="flex space-x-1 justify-start expandedLabel fontExpand ml-6">
                      And/Or
                    </label>
                  )}
                  <Controller
                    control={control}
                    name={`${customFields[0].tableName}[${index}].logic`}
                    rules={{
                      required:
                        index !== 0 &&
                        (watch(
                          `${customFields[0].tableName}[${index}].columnName`
                        ) ||
                          watch(
                            `${customFields[0].tableName}[${index}].value`
                          ) ||
                          watch(
                            `${customFields[0].tableName}[${index}].operator`
                          ))
                          ? true
                          : false,
                    }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        //label="And/Or"
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={field.value ? field.value : null}
                        required={
                          index !== 0 &&
                          (watch(
                            `${customFields[0].tableName}[${index}].columnName`
                          ) ||
                            watch(
                              `${customFields[0].tableName}[${index}].value`
                            ) ||
                            watch(
                              `${customFields[0].tableName}[${index}].operator`
                            ))
                            ? true
                            : false
                        }
                        options={AddOrOpt}
                        className={`${
                          index === 0 && customFields[0].parentRow === true
                            ? `hidden`
                            : errors?.[customFields[0]?.tableName ?? ""] &&
                              errors?.[customFields[0]?.tableName ?? ""][index]
                                ?.logic
                            ? `border-2 border-red-500 col-span-2`
                            : ""
                        }`}
                      />
                    )}
                  />
                </div>
                <div className={`col-span-2 w-full items-center gap-1 text-xs`}>
                  {index < 1 && customFields[0].parentRow === true && (
                    <label className="flex space-x-1 justify-start expandedLabel fontExpand ">
                      Field/s
                    </label>
                  )}
                  <Controller
                    control={control}
                    name={`${customFields[0].tableName}[${index}].columnName`}
                    rules={{
                      required:
                        index !== 0 &&
                        (watch(
                          `${customFields[0].tableName}[${index}].logic`
                        ) ||
                          watch(
                            `${customFields[0].tableName}[${index}].value`
                          ) ||
                          watch(
                            `${customFields[0].tableName}[${index}].operator`
                          ))
                          ? true
                          : false,
                    }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        options={selectedColumns}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                          if (!e) {
                            setValue(
                              `${customFields[0].tableName}[${index}].customReportId`,
                              0
                            );
                            setValue(
                              `${customFields[0].tableName}[${index}].customReportFilterId`,
                              0
                            );
                            setValue(
                              `${customFields[0].tableName}[${index}].logic`,
                              ""
                            );

                            setValue(
                              `${customFields[0].tableName}[${index}].operator`,
                              ""
                            );
                            setValue(
                              `${customFields[0].tableName}[${index}].value`,
                              ""
                            );
                          }
                          if (
                            index === 0 &&
                            watch(
                              `${customFields[0].tableName}[${0}].columnName`
                            )
                          ) {
                            setValue(
                              `${customFields[0].tableName}[${index}].logic`,
                              "AND"
                            );
                          }
                        }}
                        value={field.value ? field.value : null}
                        required={
                          index !== 0 &&
                          (watch(
                            `${customFields[0].tableName}[${index}].logic`
                          ) ||
                            watch(
                              `${customFields[0].tableName}[${index}].value`
                            ) ||
                            watch(
                              `${customFields[0].tableName}[${index}].operator`
                            ))
                            ? true
                            : false
                        }
                        isDisabled={watch("selectedColumns") ? false : true}
                        placeHolder={
                          !watch("selectedColumns")
                            ? "Select Column to enable"
                            : undefined
                        }
                        className={
                          errors?.[customFields[0]?.tableName ?? ""] &&
                          errors?.[customFields[0]?.tableName ?? ""][index]
                            ?.columnName &&
                          "border-2 border-red-500 col-span-2"
                        }
                      />
                    )}
                  />
                </div>
                <div className={`col-span-2 w-full items-center gap-1 text-xs`}>
                  {index < 1 && customFields[0].parentRow === true && (
                    <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                      Operator
                    </label>
                  )}{" "}
                  <TextInputLabelHookForm
                    type="text"
                    register={register(
                      `${customFields[0].tableName}[${index}].operator`,
                      {
                        required: {
                          value:
                            index !== 0 &&
                            (watch(
                              `${customFields[0].tableName}[${index}].logic`
                            ) ||
                              watch(
                                `${customFields[0].tableName}[${index}].columnName`
                              ) ||
                              watch(
                                `${customFields[0].tableName}[${index}].value`
                              ))
                              ? true
                              : false,
                          message: "Required Field",
                        },
                      }
                    )}
                    className={
                      errors?.[customFields[0]?.tableName ?? ""] &&
                      errors?.[customFields[0]?.tableName ?? ""][index]
                        ?.operator &&
                      "border-2 border-red-500 col-span-2"
                    }
                  />
                </div>
                <div className={`col-span-2 w-full items-center gap-1 text-xs`}>
                  {index < 1 && customFields[0].parentRow === true && (
                    <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                      Value
                    </label>
                  )}{" "}
                  <TextInputLabelHookForm
                    type="text"
                    register={register(
                      `${customFields[0].tableName}[${index}].value`,
                      {
                        required: {
                          value:
                            index !== 0 &&
                            (watch(
                              `${customFields[0].tableName}[${index}].logic`
                            ) ||
                              watch(
                                `${customFields[0].tableName}[${index}].columnName`
                              ) ||
                              watch(
                                `${customFields[0].tableName}[${index}].operator`
                              ))
                              ? true
                              : false,
                          message: "Required Field",
                        },
                      }
                    )}
                    className={
                      errors?.[customFields[0]?.tableName ?? ""] &&
                      errors?.[customFields[0]?.tableName ?? ""][index]
                        ?.value &&
                      "border-2 border-red-500 col-span-2"
                    }
                  />
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default CustomReportFields;
